export function initTabs() {
  const tabList = document.querySelector('[role="tablist"]');
  if (!tabList) return;

  const tabs = Array.from(tabList.querySelectorAll('[role="tab"]'));
  const panels = Array.from(document.querySelectorAll('[role="tabpanel"]'));

  function activateTab(targetTab) {
    tabs.forEach(tab => {
      const isSelected = tab === targetTab;
      tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      tab.classList.toggle('active', isSelected);
      tab.setAttribute('tabindex', isSelected ? '0' : '-1');
    });

    const targetPanelId = targetTab.getAttribute('aria-controls');
    panels.forEach(panel => {
      const isCurrent = panel.id === targetPanelId;
      panel.classList.toggle('active', isCurrent);
      panel.hidden = !isCurrent;
    });
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', () => activateTab(tab));

    tab.addEventListener('keydown', (e) => {
      const index = tabs.indexOf(tab);
      let newTab = null;

      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        e.preventDefault();
        newTab = tabs[(index + 1) % tabs.length];
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        e.preventDefault();
        newTab = tabs[(index - 1 + tabs.length) % tabs.length];
      } else if (e.key === 'Home') {
        e.preventDefault();
        newTab = tabs[0];
      } else if (e.key === 'End') {
        e.preventDefault();
        newTab = tabs[tabs.length - 1];
      }

      if (newTab) {
        newTab.focus();
        activateTab(newTab);
      }
    });
  });
}
